import {
    CustomTable,
    TableTypes,
} from "@/components/Home/TradingChartInfoSection/analytics/shared/ui/table";

export const PivotPointsTable = ({ data }: { data: any; }) => {
    return <CustomTable type={TableTypes.pivotPoints} data={data} />;
};
